export const VideoserviceFileStatus = {
	PENDING:   'pending',
	AVAILABLE: 'available',
	FAILURE:   'failure',
};
